import produce from 'immer';
import * as CONSTANTS from './constants';

const initialState = {
  cancelDeferredTransaction: {
    loading: false,
    error: null,
    success: null
  },
  ifCanceledDeferredTransaction: {
    loading: false,
    error: null,
    data: null
  },
  deferredCompanyTransactions: {
    loading: false,
    error: null,
    data: []
  },
  deferredUserTransactions: {
    loading: false,
    error: null,
    data: []
  }
};

const payByInvitationReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CONSTANTS.CANCEL_DEFERRED_TRANSACTION_REQUEST:
        draft.cancelDeferredTransaction = {
          loading: true,
          error: null,
          success: false
        };
        break;
      case CONSTANTS.CANCEL_DEFERRED_TRANSACTION_SUCCESS:
        draft.cancelDeferredTransaction = {
          loading: false,
          error: null,
          success: true
        };
        break;
      case CONSTANTS.CANCEL_DEFERRED_TRANSACTION_FAIL:
        draft.cancelDeferredTransaction = {
          loading: false,
          error: action.error,
          data: false
        };
        break;

      case CONSTANTS.CHECK_IF_CANCELED_DEFERRED_TRANSACTION_REQUEST:
        draft.ifCanceledDeferredTransaction = {
          loading: true,
          error: null,
          data: null
        };
        break;
      case CONSTANTS.CHECK_IF_CANCELED_DEFERRED_TRANSACTION_SUCCESS:
        draft.ifCanceledDeferredTransaction = {
          loading: false,
          error: null,
          data: action.data
        };
        break;
      case CONSTANTS.CHECK_IF_CANCELED_DEFERRED_TRANSACTION_FAIL:
        draft.ifCanceledDeferredTransaction = {
          loading: false,
          error: action.error,
          data: null
        };
        break;

      case CONSTANTS.FETCH_DEFERRED_COMPANY_TRANSACTION_REQUEST:
        draft.deferredCompanyTransactions = {
          loading: true,
          error: null,
          data: []
        };
        break;
      case CONSTANTS.FETCH_DEFERRED_COMPANY_TRANSACTION_SUCCESS:
        draft.deferredCompanyTransactions = {
          loading: false,
          error: null,
          data: action.data
        };
        break;
      case CONSTANTS.FETCH_DEFERRED_COMPANY_TRANSACTION_FAIL:
        draft.deferredCompanyTransactions = {
          loading: false,
          error: action.error,
          data: []
        };
        break;

      case CONSTANTS.FETCH_DEFERRED_USER_TRANSACTION_REQUEST:
        draft.deferredUserTransactions = {
          loading: true,
          error: null,
          data: []
        };
        break;
      case CONSTANTS.FETCH_DEFERRED_USER_TRANSACTION_SUCCESS:
        draft.deferredUserTransactions = {
          loading: false,
          error: null,
          data: action.data
        };
        break;
      case CONSTANTS.FETCH_DEFERRED_USER_TRANSACTION_FAIL:
        draft.deferredUserTransactions = {
          loading: false,
          error: action.error,
          data: []
        };
        break;

      default:
        break;
    }
  });

export default payByInvitationReducer;
